import React from 'react';
import MarkdownIt from 'markdown-it';

const Markdown = ({ str }) => (
  <span dangerouslySetInnerHTML={{__html: MarkdownIt('commonmark').render(str)}} />
);

export default Markdown;